export const PICE_ARR = {
  code01: {
    title: "단서 조각 #1",
    content: `
      <div class="mb16">
        [암호문]<br/>
        "TOMORROW" (내일)
      </div>
      <div class="mb16">
        [사용 언어]<br/>
        영어
      </div>
      <div class="mb16">
        [분석] 범인은 영어를 능숙하게 사용함.<br/>업무에서 영어를 자주 쓰는<br/>사람일 가능성.
      </div>
    `,
    status: "none",
    keyText: "",
  },
  time02: {
    title: "단서 조각 #2",
    content: `
      <div class="mb16">
        최다 야근 기록: 18회 (한 달 기준)
      </div>
      <div class="mb16">
        [분석]<br/>
        이 사람은 한 달 내내 고르게 야근함.<br/>
        특별한 시즌이나 이유 없이<br/>
        지속적으로 야근.
      </div>
      <div class="mb16">
        [비교]<br/>
        - 12회 야근자:<br/>
        11월 인사평가 시즌이라 집중 야근<br/>
        - 18회 야근자:<br/>
        명확한 이유 없이 계속 야근
      </div>
      <div class="mb16">
        [의문]<br/>
        18회 야근의 진짜 이유는 무엇인가?
      </div>
    `,
    status: "none",
    keyText: "",
  },
  time03: {
    title: "단서 조각 #3",
    content: `
      <div>
        범죄 현장: 회의실
      </div>
    `,
    status: "none",
    keyText: "",
  },
  trace4: {
    title: "단서 조각 #4",
    content: `
      <div>
        스파이X는 회사 근처<br/>
        네일아트샵에서 기밀 정보를 공유했다.<br/>
        사건현장에 손톱 부스러기가 있는 것을 추가로 발견했다.
      </div>
    `,
    status: "none",
    keyText: "",
  },
  mind05: {
    title: "단서 조각 #5",
    content: `
      <div class="mb16">
        [결정적 전환점]<br/>
        10월 25일: 감정 급변<br/>
        → 이날 무언가 중대한 결심<br/>
        → "인정받는 다른 방법"을 찾음 
      </div>
      <div class="mb16">
        [사건 발생]<br/>
        11월 8일 → 10월 25일부터<br/>
        2주간 준비 기간
      </div>
    `,
    status: "none",
    keyText: "",
  },
  file06: {
    title: "단서 조각 #6",
    content: `
      <div class="mb16">
        [45분의 비밀]<br/>
        작업 시간: 45분 시작<br/>
        시각: 19:35 (대부분 퇴근 후)
      </div>
      <div class="mb16">
        이 시간이면 가능한 작업:<br/>
        ✓ 파일 전체 복사<br/>
        ✓ 내용 분석 및 편집<br/>
        ✓ 외부 전송 준비
      </div>
    `,
    status: "none",
    keyText: "",
  },
  lang07: {
    title: "단서 조각 #7",
    content: `
      <div>
        [범행 계획서]<br/>
        독일어 메모:<br/>
        "19:45에 데이터 전송"<br/>
        Daten um 19 : 15 übertragen
      </div>
    `,
    status: "none",
    keyText: "",
  },
  alarm8: {
    title: "단서 조각 #8",
    content: `
      <div>
        [타임라인 정리]<br/>
        19:35 - 파일 접근<br/>
        19:40 - 알람 발생<br/>
        19:42 - 알람 해제<br/>
        19:45 - 계획 시각<br/>
        19:47 - 실제 전송 성공
      </div>
    `,
    status: "none",
    keyText: "",
  },
  cross9: {
    title: "단서 조각 #9",
    content: `
      <div>
        [용의자B의 행동]<br/>
        시선 회피 + 손 떨림 + 숨 고르기 반복<br/>
        → 복합 거짓 신호<br/>
        <br/>
        진술 내용은<br/>
        “사건 당시 연구실”이지만,<br/>
        내적 불안과 논리 불일치 공존.
      </div>
    `,
    status: "none",
    keyText: "",
  },
};
